/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export abstract class MultipleOutputWorkflowBlock extends BaseWorkflowBlock {

        constructor(id: string, type: number, label: string) {
            super(id, type, label);
        }

        public getOutputType(): Wars.Domain.Model.Codes.Enums.BlockOutputType {
            return Wars.Domain.Model.Codes.Enums.BlockOutputType.Multiple;
        }
    }
}